import GoogleCalendarCallback from "./components/calendar/GoogleCalendarCallback";
import React from "react";
import { ThemeProvider } from "./theme/ThemeContext";
import "./theme/theme.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import Landing from "./pages/Landing";
import Admin from "./pages/Admin";
import InstallerPortal from "./pages/InstallerPortal";
import ServicePage from "./pages/services/ServicePage";
import AssemblyPage from "./pages/services/AssemblyPage";
import { assemblyPages } from "./seo/assemblyPages";
import CityPage from "./pages/locations/CityPage";
import SchedulePage from "./pages/SchedulePage";
import PaymentPage from "./pages/PaymentPage";
import QuoteResponsePage from "./pages/QuoteResponsePage";
import RouteMetadata from "./seo/RouteMetadata";
import NotFound from "./seo/NotFound";
import BusinessInterest from "./pages/BusinessInterest";
import ProAccess from "./pages/ProAccess";
import Contact from "./pages/Contact";
import WhatsAppFloat from "./components/WhatsAppFloat";
import PrivateRoute from "./lib/PrivateRoute";

function App() {
  return (
    <ThemeProvider><LanguageProvider>
      <BrowserRouter>
        <RouteMetadata />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/calendar/connect" element={<PrivateRoute Page={GoogleCalendarCallback} />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/pro" element={<PrivateRoute Page={ProAccess} />} />
          <Route path="/partners" element={<BusinessInterest key="partner" kind="partner" />} />
          <Route path="/installer" element={<PrivateRoute Page={InstallerPortal} />} />
          <Route path="/payment" element={<PrivateRoute Page={PaymentPage} />} />
          <Route path="/quote/respond" element={<PrivateRoute Page={QuoteResponsePage} />} />
          <Route path="/schedule/:qrId" element={<PrivateRoute Page={SchedulePage} />} />
          <Route path="/locations/:city" element={<CityPage />} />
          {Object.keys(assemblyPages).map(path => <Route key={path} path={path} element={<AssemblyPage />} />)}
          <Route path="/:slug" element={<ServicePage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <WhatsAppFloat />
      </BrowserRouter>
    </LanguageProvider></ThemeProvider>
  );
}

export default App;
